export default "__VITE_ASSET__BT1BZeXd__"